'use strict';

angular.module('gestiondecriseApp').component('crewHistoryComponent', {
  templateUrl: 'views/crew/history.html',
  controller: 'CrewHistoryCtrl',
});
